<template>
  <div class="text-center">
    <v-btn x-large color="success" href="mailto:hi@andromeda.technology" style="color: white" block class="pa-16">
      <v-icon x-large class="pr-2">mdi-mail</v-icon>
      <h2>Get in touch</h2>
    </v-btn>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "ContactComponent",
  components: {
    //
  }
});
</script>